import { render } from "./InventoryDialogs.vue?vue&type=template&id=6ef1a93d&scoped=true&ts=true"
import script from "./InventoryDialogs.vue?vue&type=script&lang=ts"
export * from "./InventoryDialogs.vue?vue&type=script&lang=ts"

import "./InventoryDialogs.vue?vue&type=style&index=0&id=6ef1a93d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ef1a93d"]])

export default __exports__